// Fetch

export const FETCH = 'prerequisites.FETCH'
export const FETCH_STARTED = 'prerequisites.FETCH_STARTED'
export const FETCH_FULFILLED = 'prerequisites.FETCH_FULFILLED'
export const FETCH_REJECTED = 'prerequisites.FETCH_REJECTED'
export const FETCH_CANCELLED = 'prerequisites.FETCH_CANCELLED'
